export default __webpack_public_path__ + "static/media/img_gas_phase_en_02.6be51294.png";